import { Grid } from "@material-ui/core"
import { TextFieldSaurus } from "views/components/controles/inputs"
import { useStyles } from "./pesquisa-cliente-styles"
import { useState } from "react"

export interface PesquisaClienteProps {
    setPesquisa: (value: string) => void
}

export const PesquisaCliente = ({ setPesquisa }: PesquisaClienteProps) => {
    const classes = useStyles()
    const [searchClienteState, setSearchClienteState] = useState('')

    return (
        <Grid container item xs={12} className={classes.filtroPesquisar} style={{ padding: '8px' }}>
            <TextFieldSaurus
                searchable
                value={searchClienteState}
                label="Pesquisar Cliente"
                onChange={(e: any) => setSearchClienteState(e.target.value)}
                onSearch={() => {
                    setPesquisa(searchClienteState)
                }}
            />
        </Grid>
    )
}